import { connect } from 'react-redux'
import { resetCartForm } from 'actions/account/cart'

const mapStateToProps = ({
  cart: { cartForm },
  forms: { waiverForm },
  checkout: { paymentProfileForm }
}) => ({
  cartForm,
  waiverForm,
  paymentProfileForm
})

const actions = {
  resetCartForm
}

const withRedux = connect(mapStateToProps, actions)

export default withRedux
